import React from "react";
import { Box, Tooltip } from '@mui/material';

export default function StatusMessage(props) {
    const iconStyle = {
        width: '14px',
        height: '14px',
        marginLeft: '4px',
        opacity: 0.8
    };

    if (props.statuses?.status === "sent") {
        return (
            <Tooltip title="Message sent" arrow placement="top">
                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        style={iconStyle}
                        viewBox="0 0 24 24" 
                        strokeWidth="1.5" 
                        stroke="currentColor" 
                        fill="none" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M5 12l5 5l10 -10" />
                    </svg>
                </Box>
            </Tooltip>
        )
    } else if (props.statuses?.status === "delivered") {
        return (
            <Tooltip title="Message delivered to recipient" arrow placement="top">
                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        style={iconStyle}
                        viewBox="0 0 24 24" 
                        strokeWidth="1.5" 
                        stroke="currentColor" 
                        fill="none" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M7 12l5 5l10 -10" />
                        <path d="M2 12l5 5m5 -5l5 -5" />
                    </svg>
                </Box>
            </Tooltip>
        )
    } else if (props.statuses?.status === "read") {
        return (
            <Tooltip title="Message read by recipient" arrow placement="top">
                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        style={iconStyle}
                        viewBox="0 0 24 24" 
                        strokeWidth="1.5" 
                        stroke="currentColor" 
                        fill="none" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0" />
                        <path d="M6 21v-2a4 4 0 0 1 4 -4h4" />
                        <path d="M15 19l2 2l4 -4" />
                    </svg>
                </Box>
            </Tooltip>
        )
    } else {
        return (
            <Tooltip title="Message pending delivery" arrow placement="top">
                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                    <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        style={iconStyle}
                        viewBox="0 0 24 24" 
                        strokeWidth="1.5" 
                        stroke="currentColor" 
                        fill="none" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                        <path d="M12 7v5l3 3" />
                    </svg>
                </Box>
            </Tooltip>
        )
    }
}